import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  IKeycloakUser,
  IUserByPk,
  IUserToSaveReq
} from '../../interface';
import { UserService } from '../user/user.service';
import { KeycloakService } from './keycloak.service';
import { UsuariosService } from '../centralization/usuarios.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUser: Observable<any>;
  private readonly currentUserSubject: BehaviorSubject<any>;

  constructor(
    private readonly _http: HttpClient,
    private readonly _userService: UserService,
    private readonly keycloak: KeycloakService,
    private readonly _usuarioService: UsuariosService,
  ) {
    const storedUser = this.safeParse(localStorage.getItem('currentUser'));
    this.currentUserSubject = new BehaviorSubject<any>(storedUser);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  /** Getter del usuario actual */
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  /** Valida expiración de token */
  isTokenNoValid() {
    try {
      return this.keycloak.isTokenExpired();
    } catch {
      return true;
    }
  }

  // isTokenNoValidWithToken() {
  //   return this.keycloak.isTokenExpiredWithToken();
  // }

  /** Login usando Keycloak */
  async login() {
    console.log('Generando URL de login...');

    const options = {
      idpHint: 'google',
      redirectUri: `${window.location.origin}/login`
    };

    const url = await this.keycloak.createLoginUrl(options);


    window.location.href = url;
  }

  /**
   * Cargar información del usuario desde Keycloak,
   * guardar en contexto y registrar en BD si no existe.
   */
  // async setUser(): Promise<boolean> {
  //   try {
  //     const userInfo = await this.keycloak.loadUserInfo();
  //     const user = {
  //       ...userInfo,
  //       token: this.keycloak.getToken()
  //     };

  //     console.log('user', user);

  //     await this.settingActivo(user);

  //     return await new Promise<boolean>((resolve, reject) => {
  //       this._userService.getByEmail(user.email).subscribe({
  //         next: async (data: { data: IUserByPk }) => {

  //           if (!data.data) {
  //             console.log('User not found, saving user...');

  //             try {
  //              await this.saveUser(user);
  //               resolve(true);
  //             } catch (saveError) {
  //               console.error('Error saving user:', saveError);
  //               reject('Error saving user');
  //             }

  //           } else {
  //             console.log('User found:', data);
  //             resolve(true);
  //           }
  //         },
  //         error: (err) => {
  //           console.error('Error fetching user by email:', err);
  //           reject('Error fetching user');
  //         }
  //       });
  //     });

  //   } catch (err) {
  //     console.error('Error during setUser:', err);
  //     throw 'Error during user setup';
  //   }
  // }

  /**
   * Guarda usuario en la BD si no existe.
   */
  saveUser(user: IKeycloakUser): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const payload: IUserToSaveReq = {
        usId: 0,
        usNames: user.attributes?.name?.[0] || '',
        usRut: '',
        usEmail: user.email,
        usActive: true,
        usPhone: '',
        profiles: [],
        areas: [],
        usGuest: true
      };

      this._userService.createUpdateUser(payload).subscribe({
        next: (data) => {
          console.log('User saved successfully:', data);
          resolve(true);
        },
        error: (error) => {
          console.error('Error saving user:', error);
          reject(error);
        }
      });
    });
  }

  /**
   * Setea usuario en sesión localStorage + BehaviorSubject
   */
  async settingActivo(user: any): Promise<any> {
    return new Promise((resolve) => {
      if (user?.token) {
        this.currentUserSubject.next(user);
        localStorage.setItem('currentUser', JSON.stringify(user));
        resolve(user);
      }
    });
  }

  getToken() {
    return this.keycloak.getToken();
  }

  refreshToken() {
    return this.keycloak.refreshToken();
  }

  /**
   * Cerrar sesión
   */
  async logout() {
    try {
      localStorage.removeItem('currentUser');
      localStorage.removeItem('currentUserCr');
      if (await this.keycloak.loadUserInfo()) {
        this.keycloak.logout();
      }
      this.currentUserSubject.next(null);
    } catch {
      this.currentUserSubject.next(null);
    }
  }

  /**
   * Parseo seguro de JSON para evitar errores en localStorage
   */
  private safeParse(value: string | null): any {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }
  setUser() {
    console.log('setUser')
    return new Promise((resolve, reject) => {
      this.keycloak.loadUserInfo().then(async (userGET: any) => {
        const user = userGET;
        user.token = this.keycloak.getToken();
        console.log('user', user);
        let usuario = {
          us_nombres: `${user.firstName} ${user.lastName}`,
          us_correo: user.email,
          us_rol: 3 //posteriormente cambiar a rol invitado
        }
        await this.settingActivo(user);
        await this.guardarUsuario(usuario);
        resolve(true);
      });
    })
  }
  guardarUsuario(body: any) {
    return new Promise<void>((resolve, reject) => {
      this._usuarioService.guardarUsuario(body).subscribe({
        next: (data: any) => {
          console.log(data);
          if (data.usuario.us_estado == 1) {
            localStorage.setItem('currentUserCr', JSON.stringify(data.usuario));
            resolve()
          } else {
            //this._toastrService.info('Tu usuario debe ser activado','Contacte con el Administrador')
            reject();
          }
        },
        error: (err: any) => {
          console.log('error:', err);
          reject(err);
        }
      });
    });
  }
  isLoggedIn(): boolean {
    return this.keycloak.isLoggedIn();
  }
}
